(function () {
  'use strict';

  var hostname = window.location.hostname.toLowerCase();
  if (hostname !== 'odysslife.net' && hostname !== 'www.odysslife.net') return;

  var lifeLogoUrl = window.odyssLifeLogoUrl;
  var lifeFooterLogoUrl = window.odyssLifeFooterLogoUrl;
  var excludedText = 'script, style, noscript, textarea, [contenteditable]:not([contenteditable="false"])';

  function toLifeBranding(value) {
    return value.replace(/\bODYSS\b(?!\s+Life\b)/g, 'ODYSS Life');
  }

  function replaceText(node) {
    if (!node.parentElement || node.parentElement.closest(excludedText)) return;
    var branded = toLifeBranding(node.nodeValue);
    if (branded !== node.nodeValue) node.nodeValue = branded;
  }

  function replaceInTextNodes(root) {
    if (root.nodeType === 3) {
      replaceText(root);
      return;
    }
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) replaceText(node);
  }

  function replaceLogo(image) {
    var footer = image.matches('.obf-logo');
    var inverted = image.closest('.logo--inverted');
    var logoUrl = footer || inverted ? lifeFooterLogoUrl : lifeLogoUrl;
    if (!logoUrl) return;
    if (image.getAttribute('src') !== logoUrl) image.setAttribute('src', logoUrl);
    if (image.hasAttribute('srcset')) image.removeAttribute('srcset');
    if (image.alt !== 'ODYSS Life') image.alt = 'ODYSS Life';
    if (footer) {
      if (!image.classList.contains('obf-logo--life')) image.classList.add('obf-logo--life');
    } else {
      var width = Number(image.getAttribute('width'));
      var height = Math.round(width * 24 / 139);
      if (width > 0 && image.getAttribute('height') !== String(height)) image.setAttribute('height', height);
    }
  }

  function applyBranding(root) {
    var logoSelector = '.site-header__logo img, img.obf-logo';
    if (root.nodeType === 1 && root.matches(logoSelector)) replaceLogo(root);
    if (root.querySelectorAll) root.querySelectorAll(logoSelector).forEach(replaceLogo);
    replaceInTextNodes(root);
  }

  applyBranding(document);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyBranding(document);
    }, { once: true });
  }

  var observer = new MutationObserver(function (records) {
    records.forEach(function (record) {
      if (record.type === 'characterData') {
        replaceText(record.target);
      } else {
        record.addedNodes.forEach(applyBranding);
      }
    });
  });
  observer.observe(document.documentElement, { childList: true, characterData: true, subtree: true });
})();
